// Minimal event emitter with the same $on/$off/$emit API the Vue 2 event bus had.
// Handlers run with `this` bound to the bus, as they did when the bus was a Vue instance.
const handlers = new Map();

export const EventBus = {
  $on(event, handler) {
    if (!handlers.has(event)) handlers.set(event, new Set());
    handlers.get(event).add(handler);
    return EventBus;
  },
  $off(event, handler) {
    if (!event) {
      handlers.clear();
    } else if (!handler) {
      handlers.delete(event);
    } else if (handlers.has(event)) {
      handlers.get(event).delete(handler);
    }
    return EventBus;
  },
  $emit(event, ...args) {
    if (handlers.has(event)) {
      [...handlers.get(event)].forEach(h => h.apply(EventBus, args));
    }
    return EventBus;
  }
};
